import React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

const Header = ({
  tableManager
}) => {
  const {
    config: {
      showColumnVisibilityManager,
      components: {
        ColumnVisibility,
        Search
      },
      additionalProps: {
        header: additionalProps = {}
      },
      showSearch
    },
    columnsApi: {
      columns
    },
    columnsVisibilityApi: {
      toggleColumnVisibility
    },
    searchApi: {
      setSearchText,
      searchText
    }
  } = tableManager;
  const classNames = ('rgt-header-container ' + (additionalProps.className || '')).trim();
  return /*#__PURE__*/_jsxs("div", { ...additionalProps,
    className: classNames,
    children: [showSearch !== false ? /*#__PURE__*/_jsx(Search, {
      value: searchText,
      onChange: setSearchText,
      tableManager: tableManager
    }) : /*#__PURE__*/_jsx("span", {}), showColumnVisibilityManager !== false ? /*#__PURE__*/_jsx(ColumnVisibility, {
      columns: columns,
      onChange: toggleColumnVisibility,
      tableManager: tableManager
    }) : /*#__PURE__*/_jsx("span", {})]
  });
};

export default Header;